const renderHeader = (headerText, routes) => `
  <h2>${headerText}&nbsp;${routes}</h2>
`
export default renderHeader



// WEBPACK FOOTER //
// ./app/result-list/header.js